module.exports = __webpack_public_path__ + "assets/icon-ordered-list.5317286a.svg";